/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { WizardDTO, WizardStepDTO } from '@api/models/';
import { DtoManager } from '../generic';

export class Wizard extends DtoManager<WizardDTO> {
  constructor(dto: WizardDTO, code: string) {
    super(dto);
    this.adjustStepsAndCode(code);
  }

  checkIntegrity(): void {
    if (!this.data || !this.data.wizardCode) {
      throw new Error(`Wizard data is malformed`);
    }
  }

  /**
   * aggiusta i dati del wizard aggiunge il primo step
   * prendendo i dati del wizard e impostando il wizard code reale
   */
  private adjustStepsAndCode(code: string): void {
    const firstStep: WizardStepDTO = {
      stepCode: this.data.wizardCode,
      parentStepCode: null,
      groupCod: null,
      status: this.data.status
    };

    this.data.steps.unshift(firstStep);

    this.data.steps.forEach(step => (step.status = Number(step.status)));

    this.data.wizardCode = code;
  }
}
